const featureFlags = {
  get hideCallIndicator() {
    return !!window.__amp_feature_flags.hide_call_indicator;
  },
  get customerSituation() {
    return !!window.__amp_feature_flags.customer_situation;
  },
  get guidedServiceFlow() {
    return !!window.__amp_feature_flags.guided_service_flow;
  },
  get showPeopleTable() {
    return !!window.__amp_feature_flags.show_people_table;
  },
  get dynamicTips() {
    return (
      !!window.__amp_feature_flags.dynamic_tip_on_summary ||
      !!window.__amp_feature_flags.dynamic_tip_on_data_collection ||
      !!window.__amp_feature_flags.dynamic_tip_on_quotes ||
      !!window.__amp_feature_flags.life_insurance_pitch
    );
  },
  get dynamicTipOnSummary() {
    return !!window.__amp_feature_flags.dynamic_tip_on_summary;
  },
  get dynamicTipOnDataCollection() {
    return !!window.__amp_feature_flags.dynamic_tip_on_data_collection;
  },
  get dynamicTipOnQuotes() {
    return !!window.__amp_feature_flags.dynamic_tip_on_quotes;
  },
  get lifeInsurancePitch() {
    return !!window.__amp_feature_flags.life_insurance_pitch;
  },
  get cstGuidedSellingExperience() {
    return !!window.__amp_feature_flags.cst_guided_selling_experience;
  },
  get sendDocuments() {
    return !!window.__amp_feature_flags.send_documents;
  },
  get marketingEmailsInFeed() {
    return !!window.__amp_feature_flags.marketing_emails_in_feed;
  },
  get removeRelatedPerson() {
    return !!window.__amp_feature_flags.remove_related_person;
  },
  get customerAssetsAddHome() {
    return !!window.__amp_feature_flags.customer_assets_add_home;
  },
  get disableOldLeadPolicyActions() {
    return !!window.__amp_feature_flags.disable_old_lead_policy_actions;
  },
  get hideOldLeadViewTabs() {
    return !!window.__amp_feature_flags.hide_old_lead_view_tabs;
  },
  get loanContactEmailHardStop() {
    return !!window.__amp_feature_flags.loan_contact_email_hard_stop;
  },
  get carrierCapabilitiesCheck() {
    return !!window.__amp_feature_flags.carrier_capabilities_check;
  }
};

export default featureFlags;
